import changeEmailStore from './store';
import BaseConfirmOTP from '../components/ConfirmOTP';

interface ConfirmOTPProps {
  onNext: () => void;
}

function ConfirmOTP({ onNext }: ConfirmOTPProps) {
  const [isLoading, changeToken, confirmOTP, resendOTP] = changeEmailStore(
    (s) => [s.isLoading, s.changeToken, s.confirmOTP, s.resendOTP],
  );

  const handleSubmit = async (otp: string) => {
    const params = {
      otp,
      change_token: changeToken,
    };

    const res = await confirmOTP(params);

    if (res?.data) {
      onNext();
    }
  };

  return (
    <BaseConfirmOTP
      isLoading={isLoading}
      onSubmit={handleSubmit}
      onResend={resendOTP}
      type="email"
    />
  );
}

export default ConfirmOTP;
